import React from 'react';
import { styled } from '@mui/material/styles';
import { Link } from '@mui/material';

interface FooterWithLinksProps {
  children?: React.ReactNode;
}

const FooterWithLinks: React.FC<FooterWithLinksProps> = ({ children }) => {
  return (
    <StyledFooter>
      {children || (
        <>
        <span>2025 Biamp®</span>
        <span style={{ marginLeft: '20px' }}>
          <Link 
            href="https://www.biamp.com/legal/privacy-policy" 
            target="_blank" 
            rel="noopener noreferrer"
            sx={{ 
              color: '#646464', 
              fontSize: '14px',
              fontFamily: 'Open Sans !important',
              fontWeight: 400,
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'none',
                opacity: 0.8
              }
            }}
          >
            Privacy
          </Link>
        </span>
        <span style={{ marginLeft: '20px' }}>
          <Link 
            href="https://www.biamp.com/legal/terms-of-use" 
            target="_blank" 
            rel="noopener noreferrer"
            sx={{ 
              color: '#646464', 
              fontSize: '14px',
              fontFamily: 'Open Sans !important',
              fontWeight: 400,
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'none',
                opacity: 0.8
              }
            }}
          >
            Terms of Use
          </Link>
        </span>
        </>
      )}
    </StyledFooter>
  );
};

const StyledFooter = styled('div')({
  color: '#646464',
  fontSize: '14px',
  fontFamily: 'Open Sans !important',
  fontWeight: 400,
  wordWrap: 'break-word',
  display: 'flex',
});

export default FooterWithLinks;
